// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3008":"d1accbbe","4748":"6c777ac3"}[chunkId] + ".chunk.css";
};